import React, { useEffect, useState, useMemo, useRef } from "react";
import { FetchDataTypes, ReportsDownload } from "../../api/api";
import Cookies from "js-cookie";
import { Link, useParams } from "react-router-dom";
import { Viewer } from "@grapecity/activereports-react";
import "@grapecity/activereports/styles/ar-js-viewer.css";
import { Button } from "../../components/Button/Button";
//import reportTemplate from './myreport.rdlx';

interface ReportParameter {
  reportParameterID: number;
  reportID: number;
  parameterID: number;
  parameterName: string;
  parameterType: string;
  parameterOrderID: number;
  parameterNotes: string | null;
}

interface FormProps {
  reportParameters: ReportParameter[];
}
interface MyReportViewerProps {}

//const Form: React.FC<FormProps> = ({ reportParameters }) => {
const ReportsDetails: React.FC<FormProps> = ({ reportParameters }) => {
  const [datalist, setDatalist] = useState<[]>();
  const [formData, setFormData] = useState<{ [key: string]: any }>({});
  const [fileType, setFileType] = useState<string>("pdf");
  const [newPayload, setNewPayload] = useState<any>("");
  const [selectedname, setSelectedname] = useState<any>("");
  const [viewReports, setViewReports] = useState<any>("");
  const [IsPreview, setIsPreview] = useState(false);
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [isViewLoading, setIsViewLoading] = useState(false);
  const { reportId } = useParams();
  const viewerRef = useRef<HTMLIFrameElement | null>(null);
  const selectedClient:any = Cookies.get("client")
  useEffect(() => {
    if (reportId) {
      const reportIdNumber = parseInt(reportId, 10);

      FetchDataTypes("ReportParameters", parseInt(selectedClient), Cookies.get("newJwt"))
        .then((response) => response?.json())
        .then((response) => {
          setDatalist(
            response.filter((item: any) => item.reportID === reportIdNumber)
          );
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [reportId]);

  useEffect(() => {
    if (reportId) {
      const reportIdNumber = parseInt(reportId, 10);
      FetchDataTypes("Reports", parseInt(selectedClient), Cookies.get("newJwt"))
        .then((response) => response?.json())
        .then((response) => {
          setSelectedname(
            response.filter((item: any) => item.reportID === reportIdNumber)
          );
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [reportId]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  function formatDate(dateString: string): string {
    const [year, month, day] = dateString.split("-");
    return `${month}/${day}/${year}`;
  }

  console.log(IsPreview);
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsBtnLoading(true);
    //const payload = { fileType: fileType, Parameters: formData };
    const parametersArray = Object.entries(formData).map(([key, value]) => ({
      parameterName: key,
      value: value,
    }));
    const payload = {
      fileType: fileType,
      Parameters: parametersArray.map((param) => ({
        Name: param.parameterName,
        Value: param.parameterName.includes("Date")
          ? formatDate(param.value)
          : param.value,
      })),
    };
    setNewPayload(payload);
    console.log(payload); // You can use this data to make API calls or perform other actions.
    if (reportId) {
      const selctedID = parseInt(reportId, 10);
      fetch(
        `https://ims.akrais.com:8444/AKRAReportAPI/api/pms/reports/${selctedID}/download`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("newJwt")}`,
          },
          body: JSON.stringify(payload),
        }
      )
        .then((response) => {
          setIsBtnLoading(false);
          const payload = {
            fileType: "",
            Parameters: parametersArray.map((param) => ({
              Name: "",
              Value: "",
            })),
          };
          if (response.ok) {
            // Success

            return response.blob();
            console.log("File downloaded successfully");
          } else {
            // Error
            setIsBtnLoading(false);
            console.error("Failed to download file");
          }
        })

        .then((blob) => {
          // create a download link
          if (blob) {
            // add a check for undefined blob
            // create a download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `${selectedname[0]?.reportClassName}.${fileType}`;
            // simulate a click on the link to trigger the download
            link.click();
          }
        })

        .catch((error) => {
          setIsBtnLoading(false);
          console.error("An error occurred while downloading the file", error);
        });
    }
  };

  const handleFileTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setFileType(event.target.value);
  };

  const handlePreviewClick = () => {
    setIsViewLoading(true);
    const parametersArray = Object.entries(formData).map(([key, value]) => ({
      parameterName: key,
      value: value,
    }));
    const payload = {
      fileType: fileType,
      Parameters: parametersArray.map((param) => ({
        Name: param.parameterName,
        Value: param.parameterName.includes("Date")
          ? formatDate(param.value)
          : param.value,
      })),
    };
    if (reportId) {
      const selctedID = parseInt(reportId, 10);
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${Cookies.get("newJwt")}`);
      myHeaders.append("ClientID", `${2}`);
      myHeaders.append("Content-Type", "application/json");
      fetch(
        `https://ims.akrais.com:8444/AKRAReportAPI/api/pms/reports/${selctedID}/download`,
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(payload),
        }
      )
        .then((response) => response.blob())
        .then((blob) => {
          if (viewerRef.current) {
            const url = URL.createObjectURL(blob);
            viewerRef.current.src = url;
          }
        })

        .catch((error) => {
          console.error("An error occurred while downloading the file", error);
        });
    }
  };

  return (
    <div>
      <div className="header">
        <h1 className="header-title">Reports</h1>
      </div>
      {datalist?.length !== 0 ? (
        <form onSubmit={handleSubmit} className="row w-100 card p-4">
          {datalist?.map((item: any) => {
            return (
              <div className="col-md-5 mt-4 d-flex">
                <label
                  htmlFor={item.parameterName}
                  className="col-sm-4 col-form-label"
                >
                  {item.parameterName}
                </label>
                <div className="col-sm-8">
                  {item?.parameterType === "smalldatetime" ? (
                    <input
                      className="form-control"
                      type="date"
                      name={item.parameterName}
                      id={item.parameterName}
                      onChange={handleChange}
                      value={formData[item.parameterName] || ""}
                      required
                    />
                  ) : (
                    <input
                      className="form-control"
                      type={item.parameterType === "int" ? "number" : "text"}
                      name={item.parameterName}
                      id={item.parameterName}
                      onChange={handleChange}
                      value={formData[item.parameterName] || ""}
                      required
                    />
                  )}
                </div>
              </div>
            );
          })}
          {datalist ? (
            <>
              <div className="col-md-5 mt-4 d-flex">
                <label className="col-sm-4 col-form-label">Export As</label>
                <div className="col-sm-8">
                  <select
                    name="fileType"
                    id="fileType"
                    className="form-control"
                    onChange={handleFileTypeChange}
                  >
                    <option value="pdf">PDF</option>
                    <option value="xlsx">Excel</option>
                  </select>
                </div>
              </div>
              <div className="col-sm-12 mb-4">
                <Button
                  type="submit"
                  className="btn d-inline-flex align-items-center btn-xs btn btn-primary float-end"
                  size="medium"
                  children="Download"
                  showLoading={isBtnLoading}
                />

                <button
                  type="button"
                  className="btn d-inline-flex align-items-center btn-xs btn btn-primary float-end mx-2"
                  onClick={handlePreviewClick}
                >
                  View
                </button>

                <button
                  type="button"
                  className="btn d-inline-flex align-items-center btn-xs btn btn-link float-end"
                >
                  <Link to={`/portal/reports`}>Cancel</Link>
                </button>
              </div>
            </>
          ) : null}
        </form>
      ) : (
        <div className="row w-100 card p-4">
          <h4 className="text-center mt-4 mb-2">No Data Available</h4>
          <p className="text-center">
            <Link to={`/portal/reports`}>Click here</Link> to Reports Listing{" "}
          </p>
        </div>
      )}
      {isViewLoading ? (
        <iframe ref={viewerRef} title="Report" width="100%" height="800px" />
      ) : null}
    </div>
  );
};

export { ReportsDetails };
